import React from 'react';
import { motion } from "framer-motion";

function useIsMobile(breakpoint = 600) {
    const [isMobile, setIsMobile] = React.useState(
        typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
    );
    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);
    return isMobile;
}

const Bandeau = () => {
    const isMobile = useIsMobile();

    const styles = {
        bandeau: {
            backgroundColor: 'rgb(143, 131, 121)', // Correspond à --09dd1150
            transition: 'background-color 0.3s ease', // Ajout d'une transition similaire à "transition-with-bg"
            position: 'sticky', // Similaire à "block-sticky-bar__background"
            zIndex: 1000, // Pour s'assurer qu'il reste au-dessus
            width: '100%',
            height: '41px', // Ajustez selon vos besoins
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff', // Couleur du texte pour un bon contraste
            fontFamily: 'Lato, sans-serif',
            fontSize: isMobile ? '16px' : '30px', // Taille responsive
        },
    };

    // Définir les variantes pour l'animation du texte
    const textVariants = {
        hidden: { opacity: 0, y: 20 }, // Texte invisible et légèrement en bas
        visible: { opacity: 1, y: 0 }, // Texte visible et à sa position finale
    };

    return (
        <div style={styles.bandeau}>
            <motion.p
                initial="hidden" // État initial
                animate="visible" // État final
                variants={textVariants} // Variantes définies
                transition={{
                    duration: 0.8, // Durée totale de l'animation
                    ease: [0.25, 0.1, 0.25, 1], // Courbe Bézier personnalisée pour ralentir vers la fin
                }}
            >
                <strong>RESTOCK TRÈS PROCHAINEMENT...</strong>
            </motion.p>
        </div>
    );
};

export default Bandeau;